<template>
  <div>
    <div class="col-12">
      <label v-if="label" class="input-label">{{ label }}</label>
    </div>
    <div class="col-12">
      <!-- Default inline 1-->
      <div
        v-for="(option, index) in options"
        :key="index"
        class="custom-control custom-radio"
        :class="{ 'custom-control-inline': isInline }"
      >
        <input
          :disabled="isDisabled"
          type="radio"
          :name="name"
          :checked="value === option.value"
          :value="option.value"
          @input="updateValue($event.target.value)"
          :class="{ invalid: error }"
          class="custom-control-input"
          :id="name + index"
        />
        <label
          class="custom-control-label"
          :for="name + index"
          :class="{ invalid: error }"
        >
          {{ option.label }}
        </label>
      </div>
      <error v-if="error" variant="no-border" :message="customErrorMsg" />
    </div>
  </div>
</template>

<script>
import Error from '@/components/common/Error';

export default {
  name: 'CustomRadio',
  meta: {
    description: 'Componente común CustomRadio personalizado.',
    slots: {
      default: {
        type: 'component',
        valid: [],
      },
    },
  },
  components: {
    Error,
  },
  props: {
    value: {
      type: [String, Boolean],
      default: '',
      meta: {
        description: 'Parámetro de entrada del CustomRadio',
        example: '',
      },
    },
    options: {
      type: Array,
      default: () => [],
      meta: {
        description: 'Posibilita elegir entre varios artículos',
        example: '"[4, 8, 15, 16, 23, 42]',
      },
    },
    label: {
      type: String,
      default: () => '',
      meta: {
        description: 'Control para mostrar texto',
        example: 'Texto requerido',
      },
    },
    name: {
      type: String,
      default: () => '',
      meta: {
        description: 'Estable el nombre del radio',
        example: 'Texto requerido',
      },
    },
    error: {
      type: String,
      default: '',
      meta: {
        description: 'Estado Error',
        example: 'Texto requerido',
      },
    },
    customErrorMsg: {
      type: String,
      default: function() {
        return this.error;
      },
      meta: {
        description: 'Mensaje de error encontrado',
        example: 'Texto requerido',
      },
    },
    isInline: {
      type: Boolean,
      default: false,
      meta: {
        description: 'Establece que está en línea',
        example: 'true',
      },
    },
    isDisabled: {
      type: Boolean,
      default: function() {
        return undefined;
      },
      meta: {
        description: 'Estado disabled',
        example: 'true',
      },
    },
  },
  computed: {
    isValid() {
      return !this.error && this.dirty;
    },
  },
  methods: {
    updateValue(value) {
      if (value === 'true') {
        this.$emit('input', true);
      } else if (value === 'false') {
        this.$emit('input', false);
      } else {
        this.$emit('input', value);
      }
    },
  },
};
</script>
<style scoped>
.custom-control-input,
.custom-control-label {
  cursor: pointer;
}
.custom-control-input:checked.custom-control-input:checked:disabled
  ~ .custom-control-label::before {
  color: #d9e5df;
  border-color: #3f5b60;
  background-color: #3f5b60;
}
.custom-control-input.invalid ~ .custom-control-label::before {
  background-color: #f7d7da;
  border-color: #e85c5c;
}

.sucess-icon {
  font-size: 19px;
  position: absolute;
  top: 9px;
  right: 7px;
  color: #3f5b60;
  margin-right: 0.2rem;
}
.sucess-icon:before {
  content: '\f058';
  color: #2db782;
}
div.invalid:not(input) {
  color: #e85c5c;
}
.form-control-icon-normal {
  position: absolute;
  top: 9px;
  right: 10px;
  color: #3f5b60;
  margin-right: 0.2rem;
}
.icon-invalid {
  color: #e85c5c;
}

.custom-error i {
  float: left;
  margin-top: 15px;
  margin-right: 10px;
  color: #e85c5c;
}

.custom-control-label.invalid::before {
  border-color: #e85c5c;
  border-width: 2px;
  background: #f7d7da;
}
</style>
